// Customer API
import ajax from './_ajax';

const api = {};
api.profileInfo = function () {
  return ajax.get('/api/Customer/ProfileInfo');
};
api.getProfileInfoById = function (id) {
  return ajax.get('/api/Customer/ProfileInfo?customerId=' + id);
};
api.getMyInfo = function () {
  return ajax.get('/api/Customer/GetMyInfo');
};
api.updateInfo = function (params) {
  return ajax.post('/api/Customer/UpdateInfo', params);
};
api.updateAvatar = function (params) {
  return ajax.post('/api/customer/UpdateAvatar', params);
};
api.getMyEnterpriseInfo = function (params) {
  return ajax.get('/api/Customer/GetMyEnterpriseInfo');
};
api.updateEnterpriseInfo = function (params) {
  return ajax.post('/api/Customer/UpdateEnterpriseInfo', params);
};
api.levelupInfo = function (params) {
  return ajax.get('/api/Customer/LevelupInfo');
};
api.getSubAccount = function (params) {
  return ajax.get('/api/Customer/GetSubAccount');
};
export default api;



// WEBPACK FOOTER //
// ./src/api/customerApi.js